<template>
    <MiniModalCustom
        :is-open="video.isUploadModalOpen"
        @close="handleUploadModalClose"
    >
        <div class="mt-4"></div>
        <div
            v-if="video.isUploading"
            class="flex flex-col items-center justify-center"
        >
            <LoadingCircle></LoadingCircle>
            <div class="mt-3 text-[16px] text-bold">
                {{ video.progress }}
            </div>
        </div>
        <div
            v-if="video.isUploadComplete"
            class="flex flex-col items-center justify-center"
        >
            <ion-icon
                name="checkmark-circle-outline"
                class="text-green-500 text-[40px]"
            ></ion-icon>
            <div class="mt-3 text-[16px] text-bold">
                Screen recording uploaded
            </div>
        </div>
    </MiniModalCustom>
    <Teleport to="body" v-show="shareState.shareTrack">
        <div
            id="screenshare-track"
            v-show="shareState.shareTrack"
            :style="{
                width: meetingBoardRef.width + 'px',
                height: meetingBoardRef.height - (isCollapsed ? 0 : 80) + 'px',
                top: meetingBoardRef.top + 'px',
                left: meetingBoardRef.left + 'px',
            }"
            class="fixed z-[1000]"
        >
            <video
                playsinline
                autoplay
                ref="screenshareVideo"
                class="screenshare-video w-full h-full relative bg-gray-500"
            ></video>
        </div>
    </Teleport>
    <div
        id="meet-widget"
        :class="[
            `meet-widget`,
            { 'meet-widget--collapsed': $root.$data.sidebarCollapsed },
        ]"
        :style="{
            marginBottom: isCollapsed ? '16px' : '4px',
        }"
    >
        <div
            class="fixed top-4 flex items-center justify-center w-full"
            v-if="shareState.isSharing"
        >
            <div
                class="
                    m-auto
                    w-auto
                    flex-shrink flex-grow-0
                    bg-gray-700
                    text-red-300
                    py-2
                    px-4
                    rounded-full
                    text-xs
                    shadow-lg
                "
            >
                You are sharing your screen
            </div>
        </div>
        <div
            class="fixed top-4 flex items-center justify-center w-full"
            v-if="shareState.isSomeoneSharing && shareState.shareData"
        >
            <div
                class="
                    m-auto
                    w-auto
                    flex-shrink flex-grow-0
                    bg-gray-700
                    text-red-300
                    py-2
                    px-4
                    rounded-full
                    text-xs
                    shadow-lg
                "
            >
                {{ shareState.shareData.name }} is sharing their screen
            </div>
        </div>
        <div
            class="active-speaker"
            v-if="activeSpeaker && activeSpeaker.trim().length > 0"
        >
            <ion-icon name="megaphone-outline"></ion-icon>
            {{ activeSpeaker }}
        </div>
        <div
            class="controls"
            :style="{
                marginBottom: isCollapsed ? '16px' : 0,
            }"
        >
            <button
                type="button"
                class="hms-button active"
                v-if="isAudioActive"
                title="Mute Audio"
                @click="toggleAudio(false)"
            >
                <ion-icon name="mic-outline"></ion-icon>
            </button>
            <button
                type="button"
                class="hms-button"
                v-else
                title="Unmute Audio"
                @click="toggleAudio(true)"
            >
                <ion-icon name="mic-off-outline"></ion-icon>
            </button>
            <button
                type="button"
                class="hms-button active"
                title="DIsable Video"
                v-if="isVideoActive"
                @click="toggleVideo(false)"
            >
                <ion-icon name="videocam-outline"></ion-icon>
            </button>
            <button
                type="button"
                class="hms-button"
                v-else
                title="Enable Video"
                @click="toggleVideo(true)"
            >
                <ion-icon name="videocam-off-outline"></ion-icon>
            </button>

            <button
                type="button"
                class="hms-button active relative"
                ref="chatButton"
                title="Open Chat"
                @click="toggleChatVisible()"
                :class="{ 'animate-notification': unseenMessage }"
            >
                <div
                    class="
                        w-4
                        h-4
                        bg-red-400
                        rounded-full
                        absolute
                        -top-1
                        -right-1
                    "
                    v-if="unseenMessage"
                ></div>
                <ion-icon name="chatbubbles-outline"></ion-icon>
            </button>
            <Teleport to="body" v-show="chatVisible">
                <div
                    class="
                        fixed
                        top-[120px]
                        right-4
                        w-[320px]
                        h-[calc(100vh-120px-160px)]
                        text-xs
                        bg-white
                        rounded-md
                        p-2
                        shadow-lg
                        z-20
                    "
                    ref="chatContainer"
                    v-show="chatVisible"
                >
                    <div class="h-full flex flex-col gap-2">
                        <div class="text-right">
                            <button @click="toggleChatVisible" class="p-2">
                                <ion-icon name="close"></ion-icon>
                            </button>
                        </div>
                        <div
                            class="
                                flex flex-grow flex-shrink
                                items-center
                                justify-center
                                opacity-50
                            "
                            v-if="chatMessages.length === 0"
                        >
                            No messages yet
                        </div>
                        <div
                            v-show="chatMessages.length > 0"
                            class="overflow-y-scroll px-2 flex-grow flex-shrink"
                            ref="chatMessagesContainer"
                        >
                            <div
                                v-for="message in chatMessages"
                                :key="message.id"
                                class="flex"
                            >
                                <div
                                    class="my-2"
                                    :class="{
                                        'text-right ml-auto':
                                            message.sender === selfPeerId,
                                        'text-left mr-auto':
                                            message.sender !== selfPeerId,
                                    }"
                                >
                                    <div class="opacity-50 text-xs">
                                        {{ message.senderName }} -
                                        {{
                                            new Date(
                                                message.time
                                            ).toLocaleTimeString()
                                        }}
                                    </div>
                                    <div
                                        class="rounded-md py-2 px-3 mt-1"
                                        :class="{
                                            'bg-primary text-white text-right':
                                                message.sender === selfPeerId,
                                            'bg-gray-200 text-left text-black':
                                                message.sender !== selfPeerId,
                                        }"
                                    >
                                        {{ message.message }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center gap-2">
                            <input
                                type="text"
                                ref="chatInput"
                                v-model="chatMessage"
                                class="
                                    bg-transparent
                                    py-2
                                    px-3
                                    outline-none
                                    flex-grow flex-shrink
                                "
                                placeholder="Send a text message"
                                @keydown.enter.prevent="sendMessage"
                            />
                            <button
                                type="button"
                                @click="sendMessage"
                                class="
                                    rounded-full
                                    w-[32px]
                                    h-[32px]
                                    flex-grow-0 flex-shrink-0 flex
                                    items-center
                                    justify-center
                                    hover:text-primary
                                "
                            >
                                <ion-icon name="paper-plane-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </Teleport>

            <button
                v-if="!isMobile()"
                type="button"
                class="hms-button gray"
                :title="isBlurActive ? 'Disable Blur' : 'Enable Blur'"
                :class="{ 'active-blue': isBlurActive }"
                @click="toggleBlur(!isBlurActive)"
            >
                <ion-icon name="sparkles-outline"></ion-icon>
            </button>
            <button
                type="button"
                class="hms-button gray"
                :title="isCollapsed ? 'Expand' : 'Collapse'"
                :class="{ 'active-blue': isCollapsed }"
                @click="isCollapsed = !isCollapsed"
            >
                <ion-icon
                    v-if="!isCollapsed"
                    name="caret-down-circle-outline"
                ></ion-icon>
                <ion-icon
                    v-if="isCollapsed"
                    name="caret-up-circle-outline"
                ></ion-icon>
            </button>
            <button
                v-if="false"
                type="button"
                title="Save"
                class="hms-button gray"
                @click="triggerSave()"
            >
                <ion-icon name="save-outline"></ion-icon>
            </button>
            <button
                v-if="!isRecording && !isMobile() && canRecord"
                type="button"
                title="Record"
                class="hms-button gray"
                @click="_startRecord()"
            >
                <ion-icon name="radio-button-on-outline"></ion-icon>
            </button>
            <button
                v-if="isRecording && !isMobile()"
                type="button"
                title="Record stop"
                class="hms-button active-green"
                @click="_stopRecord()"
            >
                <ion-icon name="radio-button-on-outline"></ion-icon>
            </button>
            <button
                v-if="!isMobile() && isScreenSharing"
                type="button"
                class="hms-button active-green"
                title="Stop Screenshare"
                @click="stopScreenshare()"
            >
                <ion-icon name="desktop-outline"></ion-icon>
            </button>
            <button
                v-if="!isMobile() && !isScreenSharing"
                type="button"
                class="hms-button gray"
                title="Start Screenshare"
                @click="startScreenshare()"
            >
                <ion-icon name="desktop-outline"></ion-icon>
            </button>
            <div style="position: relative">
                <button
                    type="button"
                    class="hms-button active"
                    title="Stream"
                    @click="showLiveStreamSetting = !showLiveStreamSetting"
                >
                    <ion-icon name="radio-outline"></ion-icon>
                </button>
                <HmsLiveStream
                    v-if="showLiveStreamSetting"
                    @close="showLiveStreamSetting = false"
                    @select="updateActiveDevice"
                    :stream="hlsStream"
                ></HmsLiveStream>
            </div>
            <div style="position: relative" v-if="!isMobile()">
                <button
                    type="button"
                    class="hms-button active"
                    title="Select Device"
                    @click="showDeviceSelector = !showDeviceSelector"
                >
                    <ion-icon
                        name="ellipsis-horizontal-circle-outline"
                    ></ion-icon>
                </button>
                <HmsDeviceSelector
                    v-if="showDeviceSelector"
                    :audio-input="device.audioInput"
                    :audio-output="device.audioOutput"
                    :video-input="device.videoInput"
                    @close="showDeviceSelector = false"
                    @select="updateActiveDevice"
                ></HmsDeviceSelector>
            </div>
        </div>
        <div class="video-container" v-if="!isCollapsed">
            <div
                class="peer"
                v-for="(peer, index) in meetingPeers"
                :key="peer.id"
            >
                <video playsinline muted autoplay ref="videoRefs"></video>
                <div class="disable-overlay" v-if="!peerData[peer.id].videoOn">
                    Video Off
                </div>
                <div class="control-overlay" v-if="permissions.mute">
                    <button
                        @click="forceMute(peer)"
                        class="manage-button"
                        title="Mute"
                    >
                        <ion-icon name="mic-off-outline"></ion-icon>
                    </button>
                    <button
                        @click="forceKick(peer)"
                        class="manage-button"
                        title="Kick"
                    >
                        <ion-icon name="log-out-outline"></ion-icon>
                    </button>
                    <button
                        @click="cameraPopout(index)"
                        class="manage-button"
                        title="Camera Pop"
                        v-if="peerData[peer.id].videoOn"
                    >
                        <ion-icon name="scan-outline"></ion-icon>
                    </button>
                </div>
                <div class="name">
                    {{ peer.isLocal ? "You" : peer.name }}
                </div>
            </div>
        </div>
    </div>
    <Teleport to="body" v-if="!chatVisible">
        <div
            v-if="!chatVisible"
            class="fixed bottom-[140px] right-4 z-50 max-w-[320px]"
            @click="toggleChatVisible"
        >
            <TransitionGroup
                class="overflow-y-scroll px-2"
                name="recent-messages"
                tag="div"
            >
                <div
                    v-for="message in recentMessages"
                    :key="message.id"
                    class="
                        flex
                        bg-gray-900
                        text-white
                        bg-opacity-50
                        p-2
                        rounded-md
                        my-1
                    "
                >
                    <div>
                        <div class="opacity-50 text-xs">
                            {{ message.senderName }} -
                            {{ new Date(message.time).toLocaleTimeString() }}
                        </div>
                        <div class="mt-1 text-xs">
                            {{ message.message }}
                        </div>
                    </div>
                </div>
            </TransitionGroup>
        </div>
    </Teleport>
    <ModalCustom
        :is-open="saveModalOpen"
        @close="tryCloseSaveModal"
        title="Save Play"
    >
        <div>
            <form method="post" :action="playApi" @submit.prevent="savePlay">
                <input type="hidden" name="_token" :value="$root.csrfToken" />
                <input type="hidden" name="link" :value="code" />
                <app-input
                    name="play_name"
                    placeholder="Play name"
                    type="text"
                    required
                ></app-input>
                <div class="mt-2">
                    <app-select name="playbook_id" required>
                        <option value="-1">Draft</option>
                        <option
                            v-for="playbook in playbooks"
                            :key="playbook.playbook_id"
                        >
                            {{ playbook.playbook_title }}
                        </option>
                    </app-select>
                </div>
                <div class="text-right mt-2">
                    <app-button type="submit" :disabled="isSaving">
                        {{ isSaving ? "Saving..." : "Save" }}
                    </app-button>
                </div>
            </form>
        </div>
    </ModalCustom>

    <div
        v-if="showIdleModal"
        class="
            z-[100000]
            fixed
            top-0
            left-0
            bg-black bg-opacity-25
            backdrop-filter
            w-full
            h-full
            flex
            items-center
            justify-center
        "
    >
        <div class="bg-white rounded-lg shadow-lg p-8 max-w-screen-md mx-auto">
            <h3 class="text-2xl font-semibold">Idle Room</h3>
            <p class="my-8">
                There has been no activity in the meeting room for the last 5
                mins.
            </p>
            <div class="bg-orange-100 text-orange-900 p-4 rounded-md">
                You will be redirected out in
                {{ idleTimer < 0 ? 0 : idleTimer }} seconds.
            </div>
            <div class="flex items-center gap-6">
                <button
                    class="mt-8 bg-red-500 text-white px-4 py-2 rounded-md"
                    @click="leave()"
                >
                    Leave Now
                </button>
                <button
                    class="mt-8 bg-primary text-white px-4 py-2 rounded-md"
                    @click="stay()"
                >
                    Stay
                </button>
            </div>
        </div>
    </div>

    <div
        v-if="showRecordModal"
        class="
            z-[100000]
            fixed
            top-0
            left-0
            bg-black bg-opacity-25
            backdrop-filter
            w-full
            h-full
            flex
            items-center
            justify-center
        "
    >
        <div class="bg-white rounded-lg shadow-lg p-8 max-w-screen-md mx-auto">
            <h3 class="text-2xl font-semibold">
                This meeting is being recorded
            </h3>
            <div class="bg-orange-100 text-orange-900 p-4 rounded-md my-4">
                By continuing to be in the meeting, you are consenting to be
                recorded.
            </div>

            <div class="flex items-center gap-6">
                <button
                    class="mt-8 bg-red-500 text-white px-4 py-2 rounded-md"
                    @click="leave()"
                >
                    Leave Now
                </button>
                <button
                    class="mt-8 bg-primary text-white px-4 py-2 rounded-md"
                    @click="stay()"
                >
                    Stay
                </button>
            </div>
        </div>
    </div>

    <WindowDialog
        :is-open="isCameraPopoutOpen"
        @close="closeCameraPopout"
        :title="activeCameraPopout?.name"
    >
        <video playsinline muted autoplay ref="cameraPopupVideoRef"></video>
        <div
            class="absolute"
            v-if="isCameraPopoutLoading"
            style="
                position: absolute;
                top: calc(50% - 20px);
                left: calc(50% - 20px);
            "
        >
            <LoadingCircle class=""></LoadingCircle>
        </div>
    </WindowDialog>
</template>

<script>
import { hmsActions, hmsNotifications, hmsStore } from "../hms";
import {
    HMSNotificationTypes,
    selectBroadcastMessages,
    selectIsLocalScreenShared,
    selectIsLocalVideoEnabled,
    selectIsLocalVideoPluginPresent,
    selectIsPeerAudioEnabled,
    selectIsPeerVideoEnabled,
    selectLocalMediaSettings,
    selectLocalPeerID,
    selectPeers,
    selectPeersScreenSharing,
    selectPermissions,
    selectScreenShareByPeerID,
    selectSessionStore,
    selectSpeakers,
    selectIsConnectedToRoom,
    selectHLSState,
} from "@100mslive/hms-video-store";
import HmsDeviceSelector from "./HmsDeviceSelector";
import HmsLiveStream from "./HmsLiveStream";
import { HMSVirtualBackgroundPlugin } from "@100mslive/hms-virtual-background";
import ModalCustom from "./ModalCustom";
import WindowDialog from "./WindowDialog";
import LoadingCircle from "./LoadingCircle";
import AppInput from "./AppInput";
import AppButton from "./AppButton";
import { sleep } from "../utils/timer";
import Hls from "hls.js";
import emitter from "tiny-emitter/instance";

const IDLE_TIMER_BASE = 10;
// 5 mins
const IDLE_TIMEOUT = 1000 * 60 * 5;
// const IDLE_TIMEOUT = 1000 * 10;
const IDLE_CHECK_INTERVAL = 5000;
const IDLE_LOG_INTERVAL = 5000;

export default {
    components: {
        AppButton,
        AppInput,
        ModalCustom,
        HmsDeviceSelector,
        WindowDialog,
        LoadingCircle,
    },
    computed: {
        meetingPeers() {
            return this.peers.filter((peer) => peer.roleName !== "bot");
        },
    },
    data() {
        return {
            showDeviceSelector: false,
            showLiveStreamSetting: false,
            peers: [],
            videoEnabledPeerIds: [],
            audioEnabledPeerIds: [],
            peerData: {},
            isBlurActive: true,
            isVideoActive: false,
            isAudioActive: false,
            activeSpeaker: null,
            device: {
                audioInput: null,
                audioOutput: null,
                videoInput: null,
            },
            peerState: {
                videoActive: false,
                audioActive: false,
            },
            shareState: {
                isSharing: false,
                isSomeoneSharing: false,
                shareData: null,
                shareTrack: null,
            },
            constant: {
                vb: new HMSVirtualBackgroundPlugin("blur"),
            },
            permissions: {},
            isCollapsed: true,
            isRecording: false,
            isScreenSharing: false,
            mediaRecorder: null,
            saveModalOpen: false,
            isSaving: false,
            playbooks: [],
            chatVisible: false,
            chatMessage: "",
            chatMessages: [],
            recentMessages: [],
            selfPeerId: null,
            unseenMessage: false,
            meetingBoardRef: {
                width: 0,
                height: 0,
                top: 0,
                left: 0,
            },
            lastInteractionTime: new Date().getTime(),
            showIdleModal: false,
            showRecordModal: false,
            idleTimer: IDLE_TIMER_BASE,
            idleTimerInterval: null,
            checkerInterval: null,
            isCameraPopoutOpen: false,
            isCameraPopoutLoading: false,
            activeCameraPopout: null,
            video: {
                isUploading: false,
                parts: [],
            },
            hlsStream: null,
        };
    },
    props: [
        "roomId",
        "token",
        "username",
        "playbookApi",
        "playApi",
        "code",
        "timeoutRedirect",
        "canRecord",
        "teamId",
        "roomName",
        "meetingRoomId",
    ],
    setup() {},
    created() {
        window.addEventListener("beforeunload", this.leave);
        window.addEventListener("beforeunload", this.checkUploading);
        window.addEventListener("onunload", this.leave);
        window.addEventListener("message", this.handleMessage);
    },
    destroyed() {
        window.removeEventListener("beforeunload", this.leave);
        window.removeEventListener("onunload", this.leave);
        window.removeEventListener("resize", this.syncResize);
        window.removeEventListener("message", this.handleMessage);

        document.removeEventListener("mousemove", this.trackInteraction);
        document.removeEventListener("keydown", this.trackInteraction);
        document.removeEventListener("mousedown", this.trackInteraction);
        document.removeEventListener("touchmove", this.trackInteraction);

        this.leave();
    },
    async mounted() {
        this.meetingBoardRef = {
            width: document.getElementById("meeting-board")?.offsetWidth,
            height: document.getElementById("meeting-board")?.offsetHeight,
            top: document.getElementById("meeting-board")?.offsetTop,
            left: document.getElementById("meeting-board")?.offsetLeft,
        };
        try {
            hmsActions.join({
                userName: this.username,
                authToken: this.token,
                settings: {
                    isAudioMuted: true,
                    isVideoMuted: true,
                },
            });
        } catch (e) {
            alert(e);
        }
        setInterval(() => {
            // remove recent messages older than 5 seconds
            this.recentMessages = this.recentMessages.filter(
                (message) => new Date().getTime() - message.time < 5000
            );
        }, 1000);

        for (let i = 0; i < 10; i++) {
            const isConnected = hmsStore.getState(selectIsConnectedToRoom);
            console.log({ isConnected });
            if (isConnected) {
                this.connected();
                break;
            }
            await sleep(1000);
        }

        emitter.on("change-preview-mode", function (mode) {
            hmsActions.sessionStore.set("layoutmode", mode);
        });
    },
    updated() {
        this.refreshVideoRefs();
    },
    watch: {
        peers(value) {
            this.refreshPeerData();
        },
    },
    methods: {
        renderHLSStream(hlsState) {
            /*
            console.log("is hls streaming going on - ", hlsState.running);
            const hlsUrl = hlsState.variants[0]?.url;
            if (hlsState.running) {
                console.log("hls url - ", hlsState.variants[0]?.url);

                const video = document.getElementById("stream-video");
                const browserHasNativeHLSSupport = video.canPlayType(
                    "application/vnd.apple.mpegurl"
                );
                if (Hls.isSupported()) {
                    let hls = new Hls();
                    hls.loadSource(hlsUrl);
                    hls.attachMedia(video);
                }
                // hls.js is not supported on iOS Safari, but as the browser has native support for playing HLS,
                // we can use the video element directly.
                else if (browserHasNativeHLSSupport) {
                    video.src = hlsUrl;
                }
            } else if (hlsState.error) {
                console.error("error in hls streaming - ", hlsState.error);
            } */
            if (hlsState.running) {
                this.hlsStream = hlsState.variants[0]?.url;
            } else {
                this.hlsStream = null;
            }
        },
        async connected() {
            hmsActions.sessionStore.observe(["recordState", "lastInteraction"]);
            hmsStore.subscribe(this.renderHLSStream, selectHLSState);
            hmsStore.subscribe((peerId) => {
                this.selfPeerId = peerId;
            }, selectLocalPeerID);
            hmsStore.subscribe(this.renderPeers, selectPeers);
            hmsStore.subscribe(this.setActiveSpeaker, selectSpeakers);
            hmsStore.subscribe(this.setActiveDevice, selectLocalMediaSettings);
            hmsStore.subscribe((msg) => {
                this.chatMessages = msg ?? [];
                const lastMessage = msg[msg.length - 1];
                if (lastMessage && lastMessage.sender !== this.selfPeerId) {
                    this.recentMessages.push(lastMessage);
                }
                if (msg && msg.length > 0 && !this.chatVisible) {
                    this.unseenMessage = true;
                }
                this.$nextTick(() => {
                    this.$refs.chatMessagesContainer.scrollTop =
                        this.$refs.chatMessagesContainer.scrollHeight;
                });
            }, selectBroadcastMessages); // get all broadcasted messages
            hmsStore.subscribe((value) => {
                this.peerState.videoActive = value;
            }, selectIsLocalVideoEnabled);

            hmsStore.subscribe((value) => {
                this.shareState.isSharing = value;
            }, selectIsLocalScreenShared);
            hmsStore.subscribe((value) => {
                const share = value[0];
                if (share && share.id !== this.selfPeerId) {
                    this.shareState.isSomeoneSharing = true;
                    this.shareState.shareData = share;
                    this.shareState.shareTrack = hmsStore.getState(
                        selectScreenShareByPeerID(share.id)
                    );
                    hmsActions.attachVideo(
                        this.shareState.shareTrack.id,
                        this.$refs.screenshareVideo
                    );
                } else {
                    this.shareState.isSomeoneSharing = false;
                    this.shareState.shareData = null;
                    this.shareState.shareTrack = null;
                }
            }, selectPeersScreenSharing);

            hmsStore.subscribe((value) => {
                this.permissions = value;
                console.log("Permissions: ", this.permissions);
            }, selectPermissions);

            hmsStore.subscribe((value) => {
                this.isRecording = !!value;
                if (this.isRecording && value !== this.selfPeerId) {
                    this.showRecordModal = true;
                } else {
                    this.showRecordModal = false;
                }
            }, selectSessionStore("recordState"));

            hmsNotifications.onNotification((notification) => {
                this.refreshPeerData();

                console.log("Notification: ", notification);
                if (
                    notification.type ===
                    HMSNotificationTypes.CHANGE_TRACK_STATE_REQUEST
                ) {
                    const { requestedBy, track, enabled } = notification.data;
                    console.log(
                        "Track State Change Request: ",
                        notification.data
                    );
                    // Unmute Request
                    if (enabled) {
                    } else {
                        this.isAudioActive = false;
                        alert("You have been muted");
                    }
                }
                if (
                    notification.type === HMSNotificationTypes.REMOVED_FROM_ROOM
                ) {
                    this.leave("removed");
                }
            });
            window.addEventListener("resize", this.syncResize);
            this.fetchPlaybooks();

            document.addEventListener("mousemove", this.trackInteraction);
            document.addEventListener("keydown", this.trackInteraction);
            document.addEventListener("mousedown", this.trackInteraction);
            document.addEventListener("touchmove", this.trackInteraction);

            const _this = this;
            this.checkerInterval = setInterval(() => {
                const lastInteraction = hmsStore.getState(
                    selectSessionStore("lastInteraction")
                );
                console.log(
                    "Checking for last interaction: " + lastInteraction
                );
                const lastTime = _this.hlsStream
                    ? new Date().getTime()
                    : lastInteraction ||
                      _this.lastInteractionTime ||
                      new Date().getTime();
                if (new Date().getTime() - lastTime > IDLE_TIMEOUT) {
                    clearInterval(_this.checkerInterval);
                    _this.checkerInterval = null;
                    _this.showIdleModal = true;
                    if (_this.idleTimerInterval) {
                        _this.idleTimer = IDLE_TIMER_BASE;
                        clearInterval(_this.idleTimerInterval);
                        _this.idleTimerInterval = null;
                    }
                    _this.idleTimerInterval = setInterval(() => {
                        _this.idleTimer--;
                        if (_this.idleTimer <= 0) {
                            _this.leave();
                        }
                    }, 1000);
                }
            }, IDLE_CHECK_INTERVAL);

            setInterval(() => {
                hmsActions?.sessionStore?.set(
                    "lastInteraction",
                    this.lastInteractionTime
                );
            }, IDLE_LOG_INTERVAL);
        },
        forceMute(peer) {
            hmsActions.setRemoteTrackEnabled(peer.audioTrack, false);
        },
        forceKick(peer) {
            hmsActions.removePeer(
                peer.id,
                "You have been kicked out of the meeting"
            );
        },
        handleMessage(event) {
            this.trackInteraction();
        },
        trackInteraction(e) {
            this.lastInteractionTime = new Date().getTime();
        },
        isMobile() {
            return (
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                ) ||
                screen.availWidth < 768 ||
                screen.availHeight < 480
            );
        },
        sendMessage() {
            hmsActions.sessionStore.set(
                "lastInteraction",
                new Date().getTime()
            );
            hmsActions.sendBroadcastMessage(this.chatMessage);
            this.chatMessage = "";
        },
        toggleChatVisible() {
            this.chatVisible = !this.chatVisible;
            this.unseenMessage = false;
            if (this.chatVisible) {
                this.$nextTick(() => {
                    this.$refs.chatInput.focus();
                });
            }
        },
        tryCloseSaveModal() {
            if (!this.isSaving) {
                this.saveModalOpen = false;
            }
        },
        async savePlay(e) {
            const formData = new FormData(e.target);
            this.isSaving = true;
            try {
                await axios.post(e.target.action, formData);
            } catch {
                alert("Error saving play");
            }
            this.isSaving = false;
            this.saveModalOpen = false;
        },
        fetchPlaybooks() {
            axios.get(this.playbookApi).then((response) => {
                this.playbooks = response.data;
            });
        },
        async startScreenshare() {
            try {
                await hmsActions.setScreenShareEnabled(true, {
                    forceCurrentTab: true,
                });
                this.isScreenSharing = true;
            } catch (error) {
                console.error(error);
            }
        },
        async stopScreenshare() {
            try {
                this.isScreenSharing = false;
                await hmsActions.setScreenShareEnabled(false);
            } catch (error) {
                console.error(error);
            }
        },

        mergeAudioStreams(desktopStream, voiceStream) {
            const context = new AudioContext();
            const destination = context.createMediaStreamDestination();
            let hasDesktop = false;
            let hasVoice = false;
            console.log({ audio1: desktopStream.getAudioTracks() });
            if (desktopStream && desktopStream.getAudioTracks().length > 0) {
                // If you don't want to share Audio from the desktop it should still work with just the voice.
                const source1 = context.createMediaStreamSource(desktopStream);
                const desktopGain = context.createGain();
                desktopGain.gain.value = 0.7;
                source1.connect(desktopGain).connect(destination);
                hasDesktop = true;
            }

            if (voiceStream && voiceStream.getAudioTracks().length > 0) {
                const source2 = context.createMediaStreamSource(voiceStream);
                const voiceGain = context.createGain();
                voiceGain.gain.value = 0.7;
                source2.connect(voiceGain).connect(destination);
                hasVoice = true;
            }

            return hasDesktop || hasVoice
                ? destination.stream.getAudioTracks()
                : [];
        },
        async startRecord() {
            await axios.post(`/meeting/start-record?code=${this.code}`);
            this.isRecording = true;
        },
        async stopRecord() {
            await axios.post(`/meeting/stop-record?code=${this.code}`);
            this.isRecording = false;
        },
        async _startRecordOld() {
            const desktopStream = await navigator.mediaDevices.getDisplayMedia({
                video: { MediaSource: "screen" },
                preferCurrentTab: true,
                audio: true,
            });

            const voiceStream = await navigator.mediaDevices.getUserMedia({
                audio: true,
            });
            const tracks = [
                ...desktopStream.getVideoTracks(),
                ...this.mergeAudioStreams(desktopStream, voiceStream),
            ];

            const stream = new MediaStream(tracks);

            const mime = MediaRecorder.isTypeSupported("video/mp4;codecs=avc1")
                ? "video/mp4;codecs=avc1"
                : "video/webm;codecs=vp8";

            let chunks = [];
            this.mediaRecorder = new MediaRecorder(stream, {
                mimeType: mime,
            });
            hmsActions.sessionStore.set("recordState", this.selfPeerId);

            this.mediaRecorder.addEventListener("dataavailable", (e) => {
                if (e.data.size > 0) {
                    chunks.push(e.data);
                }
            });

            const _this = this;
            this.mediaRecorder.addEventListener("stop", (e) => {
                console.log("STOPPED RECORDING");
                _this.stopRecord();
                stream.getTracks().forEach((track) => track.stop());

                let blob = new Blob(chunks, {
                    type: chunks[0].type,
                });
                this.uploadVideo(blob);
                console.log("GILAK");
            });

            this.isRecording = true;
            this.mediaRecorder.start();
        },
        async _startRecord() {
            hmsActions.sessionStore.set("recordState", this.selfPeerId);
            this.isRecording = true;

            const screenStream = await navigator.mediaDevices.getDisplayMedia({
                video: {
                    displaySurface: "browser",
                },
                audio: true,
                preferCurrentTab: true,
            });

            const micStream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                },
            });

            // 🎯 AUDIO MIXING START
            const audioContext = new AudioContext();
            const destination = audioContext.createMediaStreamDestination();

            // tab/system audio
            if (screenStream.getAudioTracks().length > 0) {
                const screenSource =
                    audioContext.createMediaStreamSource(screenStream);
                screenSource.connect(destination);
            }

            // mic audio
            const micSource = audioContext.createMediaStreamSource(micStream);
            micSource.connect(destination);

            // 🎯 FINAL STREAM (ONLY ONE AUDIO TRACK)
            const combinedStream = new MediaStream([
                ...screenStream.getVideoTracks(),
                ...destination.stream.getAudioTracks(),
            ]);

            this.mediaRecorder = new MediaRecorder(combinedStream);

            const chunks = [];

            this.mediaRecorder.ondataavailable = (e) => chunks.push(e.data);

            this.mediaRecorder.onstop = () => {
                const blob = new Blob(chunks, { type: "video/webm" });
                const url = URL.createObjectURL(blob);
                console.log(url);

                this.uploadVideo(blob);

                screenStream.getTracks().forEach((track) => track.stop());
                micStream.getTracks().forEach((track) => track.stop());
            };

            this.mediaRecorder.start();
        },
        _stopRecord() {
            if (
                this.selfPeerId !==
                hmsStore.getState(selectSessionStore("recordState"))
            ) {
                return;
            }
            if (this.mediaRecorder) {
                this.mediaRecorder.stop();
                this.mediaRecorder = null;
            }

            hmsActions.sessionStore.set("recordState");
            this.isRecording = false;
        },
        async uploadVideo(file) {
            this.video.isUploadModalOpen = true;
            this.video.isUploading = true;
            try {
                const cover = await this.getVideoCover(file);
                var filecover = new File([cover], cover.name);
                this.video.thumbnail = filecover;
                this.video.file = file;
                let dir = this.teamId;

                let key = `${new Date().toISOString()}`;
                this.video.title = `${this.roomName} - ${key}`;
                key += ".mp4";
                const createResponse = await axios.post(
                    "/upload/create-multipart-upload",
                    { key, dir }
                );
                this.video.uploadId = createResponse.data.UploadId;

                await this.uploadParts(createResponse.data.Key);
                const resp = await this.completeUpload(createResponse.data.Key);
                await this.createVideoEntry(resp.data.url);
                this.video.isUploadComplete = true;
            } catch (e) {
                console.error(e);
            }

            this.video.isUploading = false;
            this.video.parts = [];
        },
        async uploadParts(key) {
            const fileSize = this.video.file.size;
            let start = 0;
            let partNumber = 1;
            const partSize = 50 * 1024 * 1024;
            const partLength = Math.round(this.video.file.size / partSize);
            let partIndex = 0;

            while (start < fileSize) {
                const end = Math.min(start + partSize, fileSize);
                const filePart = this.video.file.slice(start, end);

                // Get presigned URL from the server
                const presignedResponse = await axios.post(
                    "/upload/generate-presigned-url",
                    {
                        key: key,
                        uploadId: this.video.uploadId,
                        partNumber,
                    }
                );

                let presignedUrl = presignedResponse.data.url;
                presignedUrl = presignedUrl.replace(
                    "http://host.docker.internal:4566",
                    "http://localhost:4566"
                );

                // Upload the file part to S3
                const uploadResponse = await axios.put(presignedUrl, filePart, {
                    headers: { "Content-Type": "application/octet-stream" },
                });

                this.video.parts.push({
                    PartNumber: partNumber,
                    ETag: uploadResponse.headers.etag,
                });

                start = end;
                partNumber++;
                partIndex++;
                const progress = Math.round((partIndex / partLength) * 100);
                if (progress < 99) {
                    this.video.progress = `Please wait, uploading ${progress}%`;
                } else {
                    this.video.progress = "Processing...";
                }
            }
        },
        async completeUpload(key) {
            return axios.post("/upload/complete-multipart-upload", {
                key: key,
                uploadId: this.video.uploadId,
                parts: this.video.parts,
            });
        },
        async createVideoEntry(url) {
            let formData = new FormData();
            formData.append("url", url);
            formData.append("thumbnail", this.video.thumbnail);
            formData.append("size", this.video.file.size);
            formData.append("title", this.video.title);
            formData.append("team_id", this.teamId);
            formData.append("room_id", this.meetingRoomId);
            formData.append("video_group_id", -3);

            try {
                await axios.post("/video/store", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                /* let url = new URL(window.location.href);
                window.location.href = url.href; */
            } catch (e) {
                console.error(e);
            }
        },
        getVideoCover(file, seekTo = 0) {
            return new Promise((resolve, reject) => {
                // load the file to a video player
                const videoPlayer = document.createElement("video");
                videoPlayer.setAttribute("src", URL.createObjectURL(file));
                videoPlayer.load();
                videoPlayer.addEventListener("error", (ex) => {
                    reject("error when loading video file", ex);
                });
                // load metadata of the video to get video duration and dimensions
                videoPlayer.addEventListener("loadedmetadata", () => {
                    // seek to user defined timestamp (in seconds) if possible
                    if (videoPlayer.duration < seekTo) {
                        reject("video is too short.");
                        return;
                    }
                    // delay seeking or else 'seeked' event won't fire on Safari
                    setTimeout(() => {
                        videoPlayer.currentTime = seekTo;
                    }, 200);
                    // extract video thumbnail once seeking is complete
                    videoPlayer.addEventListener("seeked", () => {
                        console.log("video is now paused at %ss.", seekTo);
                        // define a canvas to have the same dimension as the video
                        const canvas = document.createElement("canvas");
                        canvas.width = videoPlayer.videoWidth;
                        canvas.height = videoPlayer.videoHeight;
                        // draw the video frame to canvas
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(
                            videoPlayer,
                            0,
                            0,
                            canvas.width,
                            canvas.height
                        );
                        // return the canvas image as a blob
                        ctx.canvas.toBlob(
                            (blob) => {
                                resolve(blob);
                            },
                            "image/jpeg",
                            0.75 /* quality */
                        );
                    });
                });
            });
        },
        handleUploadModalClose() {
            this.video.isUploadComplete = false;
            this.video.isUploadModalOpen = false;
        },
        triggerSave() {
            this.saveModalOpen = true;
        },
        syncResize() {
            if (window.screen.availWidth < 640) {
                this.isCollapsed = true;
            }
        },
        async toggleBlur(value) {
            this.isBlurActive = value;

            try {
                if (value) {
                    this.constant.vb.blurValue = 50;
                    await this.constant.vb.setBackground("blur");
                } else {
                    // remove virtual background
                    await this.constant.vb.setBackground("none");
                }
            } catch (err) {
                console.log("virtual background failure - ", err);
            }
        },
        setActiveDevice({
            audioInputDeviceId,
            audioOutputDeviceId,
            videoInputDeviceId,
        }) {
            this.device.audioInput = audioInputDeviceId;
            this.device.audioOutput = audioOutputDeviceId;
            this.device.videoInput = videoInputDeviceId;
        },
        updateActiveDevice({ type, id }) {
            if (type === "audioInput") {
                hmsActions.setAudioSettings({ deviceId: id });
            }
            if (type === "audioOutput") {
                hmsActions.setAudioOutputDevice(id);
            }
            if (type === "videoInput") {
                hmsActions.setVideoSettings({ deviceId: id });
            }
            this.showDeviceSelector = false;
        },
        toggleAudio(state) {
            this.isAudioActive = state;
            hmsActions.setLocalAudioEnabled(state);
        },
        async toggleVideo(state) {
            this.isVideoActive = state;
            await hmsActions.setLocalVideoEnabled(state);
            const isVirtualBackgroundEnabled = hmsStore.getState(
                selectIsLocalVideoPluginPresent(this.constant.vb.getName())
            );
            if (!isVirtualBackgroundEnabled) {
                await hmsActions.addPluginToVideoTrack(this.constant.vb, 15);
            }
            // popout when turn on
            /* if (state) {
                const me = this.peers.findIndex(
                    (peer) => peer.id === this.selfPeerId
                );
                if (me !== -1) {
                    this.cameraPopout(me);
                }
            } else {
                this.closeCameraPopout();
            } */
        },
        renderPeers(peers) {
            this.peers = [];
            this.peers.push(...peers);
        },
        refreshVideoRefs() {
            this.peers.forEach((peer, index) => {
                if (this.$refs.videoRefs && this.$refs.videoRefs[index]) {
                    const videoElement = this.$refs.videoRefs[index];
                    console.log("Attaching video to ", index);
                    hmsActions.attachVideo(peer.videoTrack, videoElement);
                }
            });
        },
        refreshPeerData() {
            this.peers.forEach((peer, index) => {
                this.peerData[peer.id] = {
                    audioOn: hmsStore.getState(
                        selectIsPeerAudioEnabled(peer.id)
                    ),
                    videoOn: hmsStore.getState(
                        selectIsPeerVideoEnabled(peer.id)
                    ),
                    name: peer.name,
                };
            });
        },
        clearIdleTimers() {
            if (this.idleTimerInterval) {
                clearInterval(this.idleTimerInterval);
                this.idleTimerInterval = null;
            }
            if (this.checkerInterval) {
                clearInterval(this.checkerInterval);
                this.checkerInterval = null;
            }
        },
        leave(reason = "") {
            this.clearIdleTimers();
            if (this.isRecording) {
                const myRecording = hmsStore.getState(
                    selectSessionStore("recordState")
                );
                if (myRecording === this.selfPeerId) {
                    hmsActions.sessionStore.set("recordState");
                }
            }
            hmsActions.leave();
            window.location.href = this.timeoutRedirect + "&reason=" + reason;
        },
        checkUploading(event) {
            if (this.video.isUploading) {
                this.video.isUploadModalOpen = true;
                const confirmationMessage =
                    "Uploading in progress. Are you sure you want to leave?";
                event.preventDefault();
                event.returnValue = confirmationMessage;
            }
        },
        stay() {
            this.trackInteraction();
            this.showIdleModal = false;
            this.showRecordModal = false;

            this.clearIdleTimers();
            this.idleTimer = IDLE_TIMER_BASE;

            // Immediately set lastInteraction in HMS session store to prevent immediate re-trigger
            hmsActions?.sessionStore?.set(
                "lastInteraction",
                this.lastInteractionTime
            );

            const _this = this;
            this.checkerInterval = setInterval(() => {
                const lastInteraction = hmsStore.getState(
                    selectSessionStore("lastInteraction")
                );
                console.log(
                    "Checking for last interaction: " + lastInteraction
                );
                const lastTime = _this.hlsStream
                    ? new Date().getTime()
                    : lastInteraction ||
                      _this.lastInteractionTime ||
                      new Date().getTime();
                if (new Date().getTime() - lastTime > IDLE_TIMEOUT) {
                    clearInterval(_this.checkerInterval);
                    _this.checkerInterval = null;
                    _this.showIdleModal = true;
                    if (_this.idleTimerInterval) {
                        _this.idleTimer = IDLE_TIMER_BASE;
                        clearInterval(_this.idleTimerInterval);
                        _this.idleTimerInterval = null;
                    }
                    _this.idleTimerInterval = setInterval(() => {
                        _this.idleTimer--;
                        if (_this.idleTimer <= 0) {
                            _this.leave();
                        }
                    }, 1000);
                }
            }, IDLE_CHECK_INTERVAL);
        },
        setActiveSpeaker(peers) {
            this.trackInteraction();
            this.activeSpeaker = Object.values(peers)
                .map(({ peerID }) => {
                    return this.peerData[peerID].name;
                })
                .join(",");
        },
        cameraPopout(index) {
            this.isCameraPopoutOpen = true;
            this.isCameraPopoutLoading = true;
            setTimeout(() => {
                const peer = this.peers[index];
                const videoElement = this.$refs.cameraPopupVideoRef;
                console.log("Attaching video to ", index);
                hmsActions.attachVideo(peer.videoTrack, videoElement);
                this.isCameraPopoutLoading = false;
                this.activeCameraPopout = peer;
            }, 1000);
        },
        closeCameraPopout() {
            this.$refs.cameraPopupVideoRef = null;
            this.isCameraPopoutOpen = false;
            this.activeCameraPopout = null;
        },
    },
};
</script>
<style scoped>
.meet-widget {
    bottom: 0;
    left: 300px;
    width: calc(100% - 300px);
    box-sizing: border-box;
    position: fixed;
    z-index: 1000;
}

.meet-widget--collapsed {
    width: calc(100% - 50px);
    left: 50px;
}

.video-container {
    display: flex;
    gap: 16px;
    background: #000a;
    backdrop-filter: blur(16px);
    padding: 8px;
    overflow-x: scroll;
}

.peer {
    position: relative;
}

.peer .name {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 2px 4px;
    box-sizing: border-box;
    background: #000a;
    color: #fff;
    font-size: 10px;
}

.hms-button {
    line-height: 0;
    border-radius: 100px;
    padding: 12px 12px;
    background: #fa6c6c;
    border: none;
    color: #fff;
    font-size: 16px;
    transition: all 0.1s ease;
}

.hms-button.gray {
    background: #333;
}

.hms-button.active-blue {
    background: #38f;
}

.hms-button.active-green {
    background: #05ae1e;
}

.hms-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.hms-button.active {
    background: #333;
}

.controls {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    position: relative;
    top: 20px;
    z-index: 1001;
}

.active-speaker {
    background: #000a;
    padding: 4px 12px;
    font-size: 12px;
    border-radius: 100px;
    color: #fff;
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.disable-overlay {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
}

@keyframes record-animation {
    from {
        /*transform: scale(0.9);*/
        outline: solid #fa6c6c 2px;
        outline-offset: 0;
    }
    to {
        /*transform: scale(1.1);*/
        outline: solid #fa6c6c 2px;
        outline-offset: 3px;
    }
}

.animate-record {
    animation: record-animation 0.5s infinite alternate;
}

@keyframes notification-animation {
    from {
        transform: scale(0.95);
        outline: solid #fa6c6c00 1px;
    }
    to {
        transform: scale(1.05);
        outline: solid #fa6c6caa 8px;
    }
}

.animate-notification {
    animation: notification-animation 0.85s infinite alternate;
}

.recent-messages-enter-active,
.recent-messages-leave-active {
    transition: all 0.3s ease;
}

.recent-messages-enter-from,
.recent-messages-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.control-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 8px;
    background: #000a;
    display: none;
    gap: 4px;
}

.peer:hover .control-overlay {
    display: flex;
}

.manage-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 1000px;
    background: #fff;
    color: #000;
}

.manage-button:hover {
    background: #2a6496;
    color: #fff;
}
</style>
<style>
.video-container video {
    height: 96px;
    width: 154px;
    object-fit: contain;
    border-radius: 8px;
}
</style>
